module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.ttf?b0fd91bb29dcb296a9a37f8bda0a2d85";